import {RatingStars} from '@frontend/components/RatingStars'
import {trans} from '@frontend/helpers'

interface Props {
    rating: number
    reviewsCount: number
}

// Рейтинг и количество отзывов на продавца или исполнителя услуг.
export function ReviewsListRatingSummary(props: Props) {

    const {
        rating,
        reviewsCount,
    } = props

    return (
        <div>
            <div className="flex-row-center-vertical">
                <div className="fw-600 fs-4 me-2">
                    {rating}
                </div>
                <RatingStars
                    rating={rating}
                    starSize={30}
                />
            </div>
            <div className="mt-1 text-muted">
                {trans().reviews.based_on_reviews_count(
                    reviewsCount
                )}
            </div>
        </div>
    )
}
